import { TemplateRef } from '@angular/core';

import { ToastMessageOptions } from 'primeng/api';

import { attributeTypesEnum } from '../enums/attribute-types.enum';
import { MediaTypeEnum } from '../../Basic/enums/media-type.enum';

export class AttributeModel {
    id: any;
    label: string;
    value: any;
    multiDate?: Date[];
    timezone?: string;
    type: attributeTypesEnum;
    isSimilarWeb?: boolean;
    tooltipHtml?: string;
    icon?: string;
    iconToolTip?: string;
    url?: string;
    showCopyIcon?: boolean;
    copyValue?: string;
    copyToolTip?: string;
    message?: ToastMessageOptions;
    customTemplate?: TemplateRef<any>;
    customLabel?: string[];
    // Only for Media Type attributes
    mediaType?: MediaTypeEnum;
    infoTooltip?: string;
    isMultiline?: boolean;
}
